import { render, staticRenderFns } from "./InfoFieldInline.vue?vue&type=template&id=b45b4abc"
import script from "./InfoFieldInline.vue?vue&type=script&lang=js"
export * from "./InfoFieldInline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports